import React, {
  useContext,
} from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';
import { Icon } from 'anf-core-react';
import { QRCodeSVG } from 'qrcode.react';
import TmntContext from '../../context/tmnt';

const propTypes = {
  rmaNumber: PropTypes.string.isRequired,
  showRmaNumber: PropTypes.bool,
  searchUrl: PropTypes.string,
  linkLabelText: PropTypes.string,
};

export default function DropOffLocationQRCode({
  rmaNumber,
  showRmaNumber = true,
  searchUrl = 'https://local.fedex.com/en-us/qr-code-locations',
  linkLabelText = '',
}) {
  const tmntContext = useContext(TmntContext);

  return (
    <div className="drop-off-location-qr-code-wrapper" data-testid="drop-off-location-qr-code-wrapper">
      <div className="qr-code" data-testid="qr-code">
        <QRCodeSVG value={rmaNumber} />
      </div>

      {showRmaNumber && (
        <div className="rma-wrapper" data-testid="rma-wrapper">
          <p className="rma-text">{`${tmntContext.DRE_RMA_NUMBER.value}:`}</p>
          <p className="rma-number">{rmaNumber}</p>
        </div>
      )}

      <div className="qr-link-wrapper" data-testid="qr-code-search-link">
        <Link to={searchUrl} target="_blank">
          {linkLabelText || tmntContext.DRE_SEARCH_ALL_QRCODE_LOCATIONS.value}
        </Link>
        <div className="qr-external-link-icon">
          <Icon
            icon="external-link"
            labelText="external-link"
          />
        </div>
      </div>
    </div>
  );
}

DropOffLocationQRCode.propTypes = propTypes;
